import { createContext, useContext, useEffect, useState } from "react";
import i18n from "../i18n/i18n"; // Adjust path to your i18n setup

// 1. Create the context
const LoadingContext = createContext();

// 2. Hook for consuming the loading state
export const useLoading = () => useContext(LoadingContext);

// 3. Provider component
export const LoadingProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true); // Start in loading mode

  useEffect(() => {
    const loadTranslations = async () => {
      try {
        await i18n.loadLanguages(i18n.language); // Load Strapi translations
      } catch (error) {
        console.error("Failed to load i18n languages", error);
      } finally {
        setIsLoading(false); // Hide spinner once done
      }
    };

    loadTranslations();
  }, []);

  return (
    <LoadingContext.Provider value={{ isLoading, setIsLoading }}>
      {children}

      {isLoading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 bg-white d-flex justify-content-center align-items-center"
          style={{ zIndex: 9999 }}
        >
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
    </LoadingContext.Provider>
  );
};
